import {connect} from 'react-redux';
import InspectedListPage from './InspectedListPage';
import {getListByUser} from '../../actions/getListByUser';
import {setPage} from '../../actions/setPage';

const mapStateToProps = ({
                           inspectionsList: {list, page, totalPages, totalResultCount}
                         }) => ({
  list,
  page,
  totalPages,
  totalResultCount
});

export default connect(
  mapStateToProps,
  {getListByUser, setPage}
)(InspectedListPage);
